import { memo } from 'react';

import { Images } from '../../../constants/images';
import { getPathBGByIndex } from '../../../constants/pathBackground';
import { colorForGameSetId } from '../../../constants/Theme/DefaultColors';
import { SVGIconType } from '../../../constants/svgIcon';
import { Album } from '../../../models/SpaceStore/Album';
import { SvgIcon } from '../SVGIcon';
import './AlbumNode.css';

export type AlbumNodeProps = {
  album: Album;
  onClick: () => void;
};

export const AlbumNode = memo((props: AlbumNodeProps) => {
  const { album, onClick } = props;

  const albumInfo =
    album?.i18nGameSetInfo.resources[album?.i18nGameSetInfo.defaultLocale];

  const albumIcon = getPathBGByIndex(
    album?.content?.path[0]?.style.background.set ?? 0,
  );
  return (
    <div className="album-node">
      <div className="centered-container" onClick={onClick}>
        <div className="album-icon-container">
          <SvgIcon
            name={SVGIconType.BubbleShape}
            fill={colorForGameSetId(album.gameSetId)}
            className="bubble-shape"
          />

          <>
            <img
              src={
                album.icons[0]?.publicUrls?.medium ??
                albumIcon ??
                Images.speakingGameBackground
              }
              className="album-icon"
            />
            <div className="album-title-container">
              <p className="album-title">{albumInfo?.name}</p>
            </div>
          </>
        </div>
        <div className="text-component">
          <p className="album-name">{albumInfo?.name}</p>
        </div>
      </div>
    </div>
  );
});
